// extracted by mini-css-extract-plugin
export default {"Overlapping":"styles_Overlapping__bXVz1","Error":"styles_Error__u+4sh","Text":"styles_Text__6K23y"};